export default [
  {
    id: 'Paga',
    colunas: ['Paga'],
    label: 'Guia paga',
    valor: true,
  },
  {
    id: 'NaoPaga',
    colunas: ['NaoPaga'],
    label: 'Guia não paga',
    valor: false,
  },
  {
    id: 'EmAtraso',
    colunas: ['EmAtraso'],
    label: 'Em atraso',
    valor: true,
  },
  {
    id: 'PossuiObservacao',
    colunas: ['PossuiObservacao'],
    label: 'Possui observação',
    valor: true,
  },
]
